


















    import Vue from 'Vue';
    import Vuex from 'Vuex';
    import { IInitialView } from '../../../../../../CommonScripts/Abstractions';
    export default Vue.extend({
        name: 'home-button',
        components: {
        },
        data() {
            return {}
        },
        computed: {

            iconColour(): string {
                return this.$store.getters['textCssClass'];
            },
            buttonClass(): string {
                return `no-text-transform ${this.iconColour}`;
            },
            accountButtonClass(): string {
                return `mr-2 ${this.iconColour}`;
            },
            disabled(): boolean{
                return this.$store.getters['map/getInitialLocation'] === null;
            }
        },
        methods: {
            homeClickHandler(): void {
                const map = this.$store.state.map.olMap;
                const view = map.getView();
                const initialLocation: IInitialView = this.$store.getters['map/getInitialLocation'];
                view.animate({
                    center: [initialLocation.x, initialLocation.y],
                    resolution: initialLocation.resolution,
                    duration: 1500
                });
            }
        }        
    });
